import { render, staticRenderFns } from "./RepositoryForm.vue?vue&type=template&id=b808955a&scoped=true&"
import script from "./RepositoryForm.vue?vue&type=script&lang=js&"
export * from "./RepositoryForm.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryForm.vue?vue&type=style&index=0&id=b808955a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b808955a",
  null
  
)

export default component.exports